import Icon from "@core-components/icon/Icon";
import InfoCardGrid from "@core-components/info-card/InfoCardGrid";
import useAppTranslation from "@hooks/language/useAppTranslation";

export const SkinSearchFeatures = () => {
  const { t: tCommon } = useAppTranslation("common");

  return (
    <InfoCardGrid
      cards={[
        {
          icon: <Icon.FastDelivery />,
          title: tCommon("infoCards.instantDelivery.title"),
          text: tCommon("infoCards.instantDelivery.text"),
          withBackground: false,
        },
        {
          icon: <Icon.Trophy />,
          title: tCommon("infoCards.rankedReady.title"),
          text: tCommon("infoCards.rankedReady.text"),
          withBackground: false,
        },
        {
          icon: <Icon.Chat />,
          title: tCommon("infoCards.premiumSupport.title"),
          text: tCommon("infoCards.premiumSupport.text"),
          withBackground: false,
        },
      ]}
    />
  );
};
